export enum CONTENT_VIEW {
	Calendar = 'CALENDAR',
	List = 'LIST',
	Grid = 'GRID'
}
